import { DashboardLayout } from "admin/components/layout/components/DashboardLayout";
import { Navbar } from "admin/components/layout/components/Navbar";
import { useState } from "react";
import { AddRole } from "../components/AddRole";
import { AddPermission } from "../components/AddPermission";
import { hasPermission } from "utils/hasPermission";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { RolesTable } from "../components/RolesTable";
import { Segmented } from "antd";
import { AuthorizationGuard } from "../types";

export const AdminRoles = () => {
  const [addRoleModal, setAddRoleModaL] = useState(false);
  const [addPermissionModal, setAddPermissionModal] = useState(false);
  const [guardName, setGuardName] = useState<AuthorizationGuard>("admins");
  const { userInfo } = useGetUserInfo();

  const hasPermissionFor = (...permissionNames: string[]): boolean => {
    return permissionNames.some(permissionName =>
      hasPermission(userInfo, permissionName)
    );
  };

  return (
    <DashboardLayout>
      <Navbar title="Roles" description="View and manage Roles" />
      <AddRole
        open={addRoleModal}
        guardName={guardName}
        handleClose={() => setAddRoleModaL(false)}
      />
      <AddPermission
        open={addPermissionModal}
        guardName={guardName}
        handleClose={() => setAddPermissionModal(false)}
      />
      
      <div className="bg-gray-100 px-4 py-3 mt-8 rounded-md flex justify-between items-center">
        <Segmented
          value={guardName}
          onChange={(value) => setGuardName(value as AuthorizationGuard)}
          options={[
            { label: "Admins", value: "admins" },
            { label: "Users", value: "users" },
          ]}
        />

        { hasPermissionFor('Manage Admin users') &&
          <div className="flex justify-end gap-x-3">
            <button
              className="transparentButton flex items-center gap-x-2"
              onClick={()=>setAddPermissionModal(true)}
            >
              <i className="ri-shield-keyhole-line text-md"></i>
              <span>Add Permission</span>
            </button>
            <button
              className="button flex items-center gap-x-2"
              onClick={()=>setAddRoleModaL(true)}
            >
              <i className="ri-add-line text-md"></i>
              <span>Add New Role</span>
            </button>
          </div>
        }
      </div>

      <RolesTable guardName={guardName} />
    </DashboardLayout>
  );
};
